const conf = { server: "//" + window.location.hostname};
export default conf;